import React from 'react';
import { motion } from 'framer-motion';
import coins from "../assets/images/coins.png";
import headset from "../assets/images/headset.png";
import money from "../assets/images/_money.png";
import bitcoin from "../assets/images/bitcoin-icons_transactions-filled.png";
import exchange from "../assets/images/ri_exchange-fill.png";

export default function WhyFastest() {
  return (
    <>
      <div className='py-[3%] px-[8%] grid lg:grid-cols-2 bg-[#F5FAFF] md:grid-cols-1 sm:grid-cols-1 gap-6'>

        {/* Left container with spring animation */}
        <motion.div
          className="p-6"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 15 }}
        >
          <p className='flex color-[#002455] tracking-[0.3rem] uppercase text-[1rem]'>
            WHY FASTEST?
            <span className='text-[var(--second-primary-color)] text-2xl leading-[.5] pl-3'>&#8594;</span>
          </p>
          <div className='py-6 px-14 text-[#002455]'>
            {/* Dancing coins image */}
            <motion.img
              src={coins}
              alt="coins"
              className='w-[250px] pt-4'
              whileInView={{rotate: [0, -5, 5, -5, 5, 0],}}
              viewport={{once: false,}}
              transition={{
                repeat: 0.05,
                duration: 2,
                ease: "easeInOut",
              }}
            />
            <h3 className='pt-6 text-[1.4rem] font-[800] leading-[1.3]'>
              Sending International Business Payments or <span className='text-[var(--second-primary-color)]'>Sending Money</span> to <span className='text-[#2E42A5]'>Family Overseas?</span>
            </h3>
            <p className='text-[.9rem] pt-8'>Fastest is your Fast and Reliable Solution</p>
          </div>
        </motion.div>

        {/* Right container with scroll animation for cards */}
        <div className="grid grid-cols-2 gap-8 text-[#002455]">
          {[
            {
              img: headset,
              title: '24/7 Customer Support',
              desc: 'Round-the-clock assistance to address any inquiries or issues.'
            },
            {
              img: bitcoin,
              title: 'Extra-Secure Transactions',
              desc: 'Advanced encryption and security protocols to protect users’ funds and personal information.'
            },
            {
              img: exchange,
              title: 'Great Exchange Rates',
              desc: 'Capability to send and receive money in over 10+ countries with competitive exchange rates.'
            },
            {
              img: money,
              title: 'Get your Money',
              desc: 'Utilizing cutting-edge technology to ensure transfers are completed in seconds.'
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              className='bg-[#E8F1FD] p-4 rounded-md'
              initial={{ y: 20, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              whileHover={{ scale: 1.05 }}
              transition={{ delay: i * 0.2, duration: 0.5, type: "tween" }}
            >
              <img src={item.img} alt="" className='w-[44px]' />
              <h4 className='font-[800] text-[1rem] py-4'>{item.title}</h4>
              <p className='text-[.9rem]'>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </>
  )
}
